var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wl-card__slider__image",class:_vm.slide === _vm.id ? 'wl-card__slider__image--active' : '',style:(("background-image: url(" + _vm.productImage + ")"))})}
var staticRenderFns = []

export { render, staticRenderFns }